<template>
  <div class="BuildABox">
    <!-- Conversion Pixel for [lead]- DO NOT MODIFY --><img src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=ea9067b2-6212-4216-9be0-b7a1465c320d" width="1" height="1" border="0"><!-- End of Conversion Pixel -->
    <Page1 @changepage="changePage($event)" v-if="currentPage == 0"></Page1>
    <!--PAGE 2 -->
    <div class="build-wrapper">
      <div class="builder-content-wrapper">
        <div id="scroll-container" class="builder-experience-container no-scrollbar" v-show="currentPage > 0">
          <div v-show="currentStep > 1" id="scroll-header" class="full-view-header" :class="currentStep == 1 ? 'step2' : ''">
            <div>
              <button @click="changePage(false)">&lt; back</button>
            </div>
            <button class="happybox-button white border filters" 
            :class="[!selectedCardsOccasions.includes('View All') ? 'selected' : '',currentStep > 2 ? 'card' : '']" 
            @click="() => {$refs.cardComponent.showFilters()}"
            >
              <img v-if="!selectedCardsOccasions.includes('View All')" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
              <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
              Filters 
              <span v-if="!selectedCardsOccasions.includes('View All')">({{ selectedCardsOccasions.length }})</span>
            </button>
            <p class="steps">
              STEP {{currentStep}} OF 3<span class="dots">:</span><span class="legend">{{ currentCopy }}</span>
              <span class="dot" :class="currentStep == 1 ? 'current' : ''">
                <span :class="1 <= currentStep ? 'selected' : ''"></span>
              </span>
              <span class="dot" :class="currentStep == 2 ? 'current' : ''">
                <span :class="2 <= currentStep ? 'selected' : ''"></span>
              </span>
              <span class="dot" :class="currentStep == 3 ? 'current' : ''">
                <span :class="3 <= currentStep ? 'selected' : ''"></span>
              </span>
            </p>
            <p class="leave-builder" v-tooltip="'Save your selections for 24 hours. Inventory subject to availability'" @click="leaveBuilder">{{headerText}} <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665" alt="save cart"></p>
          </div>
          <Page3 @leavebuilder="leaveBuilder" @changepage="changePage($event)" v-if="currentPage == 1" @gostep="goStep($event)"></Page3>
          <Page4 @changepage="changePage($event)" v-if="currentPage == 2"></Page4>
          <Page5 ref="cardComponent" @changepage="changePage($event)" @gotoaddonselection="goToAddonSelection" :currentPage="currentPage" v-if="currentPage > 2" @opencart="openCart()"></Page5>
        </div>
      </div>
      <SideCartNew 
        ref="outSideCart"
        v-show="currentStep > 1"
        :isSticking="isSticking"
        :step="currentStep"
        :fromCard="fromCard"
        @changepage="changePage($event)" 
        @bundle="bundle($event)"
        @gostep="goStep($event)"
        @cardwarning="cardWarning($event)"
      />
      <SideCartMobile 
        v-if="selectedAddonProducts.length > 0" 
        @changepage="changePage($event)" 
        :step="currentStep"
        @bundle="bundle"
        />
    </div>
    <OOSPopUp
    v-if="oosIsActive"
    :oosProducts="noStockItems" 
    :firstStateProducts="currentStateSelectedAddons"
    :fromSavedCart="fromSavedCart"
    :fromCurated="fromCurated"
    @goback="closeOOSPopUp"
    @continuesaved="continueSaved"
    @continuecurated="continueCurated"
    />
  </div>
</template>
<script>
import Page1 from './components/Page1.vue';
import Page3 from './components/Page3.vue';
import Page4 from './components/Page4.vue';
import Page5 from './components/Page5.vue';
import OOSPopUp from './components/OOSPopUp.vue'
import SideCartNew from './components/SideCartNew.vue'
import SideCartMobile from './components/Step2Mobile/SideCartMobile.vue';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';

require('dotenv').config();

export default {
  components: {
    Page1,
    Page3,
    Page4,
    Page5,
    OOSPopUp,
    SideCartNew,
    SideCartMobile
  },
  watch:{
    currentCapacity:{
      handler(val, oldVal){
        if(val > oldVal && this.selectedBoxProduct){
          if(parseInt(this.selectedBoxProduct.variants[0].option1) < val)
            this.$store.commit('updateSelectedMainProduct', null);
        }
      },
    }
  },
  data() {
    return {
      currentPage: 0,
      noStockItems: [],
      oosIsActive: false,
      fromSavedCart: false,
      fromCurated: false,
      currentStateSelectedAddons: [],
      currentTime: new Date().getTime() / 100,
      isSticking: false,
      fromCard: false,
    }
  },
  computed: {
    ...mapGetters([
      'selectedOccasion',
      'addonProducts',
      'selectedAddonProducts',
      'selectedCardsOccasions',
      'currentCapacity',
      'selectedBoxProduct',
      'selectedCardProduct',
      'cardHasMessage'
    ]),
    canNext(){
      if (this.currentStep == 2 && !this.selectedBoxProduct){
        return false;
      }
      else if(this.currentStep == 3 && !this.selectedCardProduct)
        return false;

      return true
    },
    nextError(){
      if (this.currentStep == 2){
        return `<p class="title">Select a box to continue</p>`;
      }
      else if(this.currentStep == 3)
        return `<p class="title">Select a card to continue</p>`;

      return false
    },
    currentStep(){
      if(this.currentPage < 4)
        return this.currentPage;
      else {
        return 3
      }
    },
    currentCopy(){
      if(this.currentPage > 2){
        return "Pick a card design!"
      }
      else if(this.currentPage == 2){
        return "Pick a box design!"
      }

      return ""
    },
    headerText(){
      return "SAVE YOUR BOX"
    },
    breadcrumbText(){
      return `All products > ${this.selectedOccasion}`
    }
  },
  methods: {
    changePage(increment) {
      if(!this.canNext && increment){
        this.showErrorModal();
        return;
      }
      $("#PageContainer").scrollTop(0);
      $("html").scrollTop(0);
      this.logTimeSpent();
      if(increment){
        if(this.currentPage == 1){
            this.currentPage++;
        }
        else
          this.currentPage++;
      }
      else{
        this.currentPage--;
      }
      this.logStepNavigation(`Step ${this.currentStep}`);
      this.adjustHeaderandFooter();
    },
    goToAddonSelection(){
      this.currentPage = 1;
    },
    goStep(event){
      this.currentPage = event;
      if(this.currentPage == 1){
        this.$nextTick(() => {
          let container = document.getElementById("jump1");
          container.scrollIntoView();
        })
      }
    },
    cardWarning(){
      if(this.currentPage == 3){
        this.currentPage = 4;
      }
      this.$store.commit('setShowCardAlert', true );
      this.showErrorModal(`<p class="title">Please write your card message</p>`)
    },
    leaveBuilder(){
      var localProducts = this.selectedAddonProducts.filter(x => x.tags.every(x => !x.includes("QTYMIN"))).map((x) => {
        return {id: x.id ,v:x.variants[0].id,q: x.quantity}
      });
      localStorage.setItem('totalAddons',JSON.stringify(localProducts));
    },
    adjustHeaderandFooter(){
      if(this.currentPage > 0){
        $("#build-a-box").css('overflow','hidden');
      }
      else {
        $("#build-a-box").css('overflow','auto');
      }
      if(this.currentPage > 0){
        $("#shopify-section-footer").hide();
        $("#ticker").hide();
        $("#shopify-section-header").hide();
      }
      else {
        $("#shopify-section-footer").show();
        $("#shopify-section-header").show();
        $("#ticker").show();
      }
    },
    closeOOSPopUp(){
      this.fromSavedCart = false;
      this.fromCurated = false;
      this.noStockItems = [];
      this.oosIsActive = false;
      this.currentStateSelectedAddons = [];
    },
    continueSaved(){
      this.closeOOSPopUp();
      this.currentPage = 3;
      //this.adjustHeaderandFooter();
    },
    continueCurated(){
      this.closeOOSPopUp();
      this.changePage(true);
    },
    oosCurated(event){
      this.currentStateSelectedAddons = JSON.parse(JSON.stringify(this.selectedAddonProducts));
      this.fromSavedCart = false;
      this.fromCurated = true;
      this.noStockItems = event;
      this.oosIsActive = true;
    },
    logStepNavigation(label){
      ga('send', {
        hitType: 'event',
        eventCategory: 'Build A Box',
        eventAction: 'Navigation',
        eventLabel: label
      });
    },
    logTimeSpent(){
      let actualTime = new Date().getTime() / 100;
      ga('send', {
        hitType: 'event',
        eventCategory: 'Build A Box',
        eventAction: `Time Step ${this.currentStep}`,
        eventLabel: actualTime - this.currentTime,
      });
      this.currentTime = actualTime;
    },
    openCart(){
      this.fromCard = true;
      this.$refs.outSideCart.expandCart(true);
    },
    bundle(event){
      if(!this.canNext && increment){
        this.showErrorModal();
        return;
      }
      this.$refs.cardComponent.bundle(event);
    },
    showErrorModal(error = null){
      Swal.fire({
        iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
        html: error || this.nextError,
        confirmButtonText: 'Go Back',
        customClass:{
            container:"swal-custom-container",
            popup: "swal-custom-popup-3",
            title:"swal-title",
            confirmButton: "happybox-button green border",
        },
        buttonsStyling: false,
      });
    }
  },
  beforeMount() {},
  mounted() {
    var editBox = JSON.parse(localStorage.getItem("editBox"));
    if(editBox){
      this.changePage(true);
    }
    const el = document.querySelector(".full-view-header")
    const observer = new IntersectionObserver( 
      ([e]) => {
        e.target.classList.toggle("isSticky", e.intersectionRatio < 1);
        this.isSticking = e.intersectionRatio < 1;
      },
      { threshold: [1] }
    );
    observer.observe(el);
  },
  destroy() {
  }
}
</script>

<style scoped>
.builder-header{
  width: 100%;
  position: relative;
}

.builder-header .header-main{
  width: 100%;
}

.builder-header .floating-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
}

.builder-header.box .floating-container{
  left: 30%;
  width: 20%;
}

.builder-header.card .floating-container{
  left: 30%;
  width: 20%;
  transform: rotate(5deg);
}

.builder-header.card .floating-container .arrow-4{
  position: absolute;
  bottom: 15%;
  width: 5%;
  transform: rotate(50deg) scaleX(-1);
  left: 5%;
}

.builder-header.box .floating-container .arrow-1{
  position: absolute;
  width: 5%;
  transform: rotate(115deg);
  left: 20%;
  top: 30%;
}

.builder-header.box .floating-container .arrow-2{
  position: absolute;
  width: 5%;
  transform: rotate(90deg);
  left: 17%;
  bottom: 25%;
}

.builder-header.box .floating-container .arrow-3{
  position: absolute;
  width: 5%;
  transform: rotate(-90deg);
  right: 17%;
  bottom: 30%;
}

.builder-header .floating-container .title{
  font-size: 3vw;
  line-height: .5;
  font-family: Palmer Lake Print;
  text-align: center;
}

@media screen and (max-width: 767px){
  .builder-header .floating-container .title{
    font-size: 8vw;
  }

  .builder-header.box .floating-container{
    left: 50%;
    justify-content: flex-start;
    padding-top: 7%;
    transform: rotate(5deg);
  }

  .builder-header.box .floating-container .arrow-1{
    width: 12.5%;
    left: -25%;
    top: 35%;
    transform: rotate(90deg);
  }
  .builder-header.box .floating-container .arrow-2{
    width: 12.5%;
    bottom: 15%;
    left: 35%;
    transform: rotate(15deg) scaleX(-1);
  }
  .builder-header.box .floating-container .arrow-3{
    width: 12.5%;
    right: -20%;
    bottom: unset;
    top: 25%;
  }

  .builder-header.card .floating-container{
    left: 35%;
    width: 50%;
    transform: rotate(5deg);
    padding-top: 5%;
    justify-content: flex-start;
  }

  .builder-header.card .floating-container .arrow-4{
    left: 15%;
    width: 7%;
    transform: rotate(40deg) scaleX(-1);
  }
}


</style>

<style>
.global-spinner-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.3);
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;
  right: 0;
  left: 0;
}

.global-spinner-container p{
  font-size: 32px;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

.promotion{
  width: 100%;
  position: relative;
}

.promotion img{
  width: 100%;
  border-radius: 8px;
}

.promotion .floating-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 5%;
}

.promotion .floating-container .title{
  font-size: 2.5vw;
  font-family: Founders Grotesk,sans-serif;
  line-height: 1;
  color: #fff;
  padding-right: 12%;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle{
  font-size: 1vw;
  color: white;
  margin-bottom: 0.5rem;
}

.promotion .floating-container .subtitle span{
  font-style: italic;
  color: white;
}

.promotion .floating-container .happybox-button{
  width: 100%;
}

.builder-header .breadcrumb{
  color: #0f0c38;
  text-decoration: underline;
  position: absolute;
  top: 0%;
  left: 5%;
  z-index: 1;
  display: none;
}

.builder-header .breadcrumb > * {
  color: #0f0c38;
  text-decoration: underline;
  font-weight: bold;
}

.BuildABox .next-error-modal{
  width: 50%;
  background-color: white;
  position: fixed;
  left: 25%;
  padding: 5% 2.5%;
  top: 30%;
  border-radius: 8px;
  border: 1px solid #D6D6D6;
  box-shadow: 0 0 3px 0px #00000050;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.BuildABox .next-error-modal img{
  width: 4vw;
}

.BuildABox .next-error-modal p{
  font-size: 2vw;
  font-weight: bold;
}

@media screen and (max-width: 767px){
  .global-spinner-container p{
    font-size: 27px;
  }
  .promotion img{
    height: 100%;
    object-fit: cover;
  }

  .promotion .floating-container .happybox-button{
    width: 100%;
    padding: 2%;
  }

  .promotion .floating-container .title{
    font-size: 5vw;
    width: 100%;
  }

  .promotion .floating-container .subtitle{
    font-size: 2vw;
    width: 100%;
    text-align: left;
  }

  .builder-header .breadcrumb{
    top: 7.5%;
    display: block;
  }

  .BuildABox .next-error{
    font-size: 4vw;
    bottom: calc(50% - 2vw);
    left: 25%;
    width: 50%;
  }
}
</style>